import { render, staticRenderFns } from "./stock-table.vue?vue&type=template&id=dd4cdace&"
import script from "./stock-table.vue?vue&type=script&lang=js&"
export * from "./stock-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports